import { __extends } from "tslib";
import { UniversalCamera } from "./universalCamera";
import { Vector3 } from "../Maths/math.vector";
import { Node } from "../node";
Node.AddNodeConstructor("GamepadCamera", function (name, scene) {
    return function () { return new GamepadCamera(name, Vector3.Zero(), scene); };
});
/**
 * This represents a FPS type of camera. This is only here for back compat purpose.
 * Please use the UniversalCamera instead as both are identical.
 * @see https://doc.babylonjs.com/features/cameras#universal-camera
 */
var GamepadCamera = /** @class */ (function (_super) {
    __extends(GamepadCamera, _super);
    /**
     * Instantiates a new Gamepad Camera
     * This represents a FPS type of camera. This is only here for back compat purpose.
     * Please use the UniversalCamera instead as both are identical.
     * @see https://doc.babylonjs.com/features/cameras#universal-camera
     * @param name Define the name of the camera in the scene
     * @param position Define the start position of the camera in the scene
     * @param scene Define the scene the camera belongs to
     */
    function GamepadCamera(name, position, scene) {
        return _super.call(this, name, position, scene) || this;
    }
    /**
     * Gets the current object class name.
     * @return the class name
     */
    GamepadCamera.prototype.getClassName = function () {
        return "GamepadCamera";
    };
    return GamepadCamera;
}(UniversalCamera));
export { GamepadCamera };
//# sourceMappingURL=gamepadCamera.js.map